<template>
  <div>
      <section class="section-shaped my-0">
          <div class="shape shape-skew">
              <img :src="'/img/article/' +meta.image" class="img-fluid" width="100%">
          </div>

            <div class="d-none d-lg-block container shape-container">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-12">
                          <img src="/img/devconf_logo_white_poly.png" width="100%">
                        </div>
                    </div>
                </div>
            </div>

      </section>

      <section class="section section-lg pt-lg-0 mt--200">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <div class="row row-grid">
                        <div class="col-lg-12">
                            <card class="border-0" shadow body-classes="py-5" style="min-height: 500px">
                              <base-button type="info" @click="openIndex" outline class="pull-right">Meer nieuws</base-button>
                              <vue-simple-markdown :source="body"></vue-simple-markdown>
                              <p id="temp"></p>
                            </card>
                        </div>
                  </div>
                </div>
            </div>
          </div>
      </section>
  </div>
</template>

<script>
import Articles from "@/data/ArticleMetaData.js";


export default {
  data(){
    return {
      body: "# No article found",
      meta: null,
      index: 0
    }
  },
  methods: {
    openIndex(){
      location.href = '/article';
    }
  },
  created(){
    this.index = this.$route.params.index;
    //
    Articles.list().then(response => {
      this.meta = response.data[this.index];
      Articles.get(this.meta.file).then(response => {
        document.getElementById("temp").innerHTML = response.data;
        this.body = document.getElementById("temp").innerHTML ;
        document.getElementById("temp").innerHTML = "";
      });
    });
  },
  mounted(){
    document.getElementById("navbar").style.background = "rgba(85,88,92,0.5)";
  },
  beforeRouteLeave (to, from, next){
    document.getElementById("navbar").style.background = "rgba(255,255,255,0.0)";
    next();
  }
}
</script>
